export default __webpack_public_path__ + "static/media/info-mail.79351cb5.svg";